export default "__VITE_ASSET__DmFXePdX__"